
/**
 * @export
 * @enum {string}
 */
export enum EmailType {
    WELCOME_EMAIL = 'WELCOME_EMAIL',
    STARTUP_WELCOME_EMAIL = 'STARTUP_WELCOME_EMAIL',
    AM_WELCOME_EMAIL = 'AM_WELCOME_EMAIL',
    SMB_WELCOME_EMAIL = 'SMB_WELCOME_EMAIL',
    AM_WELCOME_EMAIL_NO_GIFT = 'AM_WELCOME_EMAIL_NO_GIFT',
    AM_WELCOME_EMAIL_SSO = 'AM_WELCOME_EMAIL_SSO',
    AM_WELCOME_EMAIL_SSO_NO_GIFT = 'AM_WELCOME_EMAIL_SSO_NO_GIFT',
    AM_WELCOME_EMAIL_TRIAL = 'AM_WELCOME_EMAIL_TRIAL',
    NEW_CLIENT_WELCOME_EMAIL = 'NEW_CLIENT_WELCOME_EMAIL',
    ORIGIN_WELCOME_EMAIL = 'ORIGIN_WELCOME_EMAIL',
    LLM_ONLY_WELCOME_EMAIL = 'LLM_ONLY_WELCOME_EMAIL'
}